import { render, staticRenderFns } from "./MonacoEditor.vue?vue&type=template&id=f5c25d90&scoped=true"
import script from "./MonacoEditor.vue?vue&type=script&lang=js"
export * from "./MonacoEditor.vue?vue&type=script&lang=js"
import style0 from "./MonacoEditor.vue?vue&type=style&index=0&id=f5c25d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c25d90",
  null
  
)

export default component.exports